module.exports = __webpack_public_path__ + "d1030cca2482e5a08c8e2a56cd6ae06f.png";